import maxLength from '../../../form/field-validation/max-length';
import required from '../../../form/field-validation/required';
import validEmail from '../../../form/field-validation/valid-email';

export const klarnaFieldsWithoutEmail = [
  {
    name: 'firstName',
    nameInClass: 'span-4',
    label: 'checkout.payment.method.first.name',
    required: true,
    validate: [required('klarnaFirstName'), maxLength(64)],
    autoComplete: 'first-name',
    maxLength: 64,
    autoFocus: true,
  },
  {
    name: 'lastName',
    nameInClass: 'span-4',
    label: 'checkout.payment.method.last.name',
    required: true,
    validate: [required('klarnaSurname'), maxLength(64)],
    autoComplete: 'last-name',
    maxLength: 64,
  },
];

const emailField = {
  name: 'email',
  nameInClass: 'span-4',
  label: 'referralsSocialSharing.channel.email',
  required: true,
  validate: [required('klarnaEmail'), maxLength(64), validEmail()],
  autoComplete: 'email',
  minLength: 5,
  maxLength: 99,
  type: 'email',
};

export const klarnaFieldsWithEmail = [...klarnaFieldsWithoutEmail, emailField];
